import './Footer.scss';

function Footer() {

    return (
        <footer className="footer">
            <p>© 2026 Mayank Sharma.</p>
        </footer>
    )
}

export default Footer;